module.exports = __webpack_public_path__ + "img/王全国.a54c5e53.jpg";